import React from "react";
/**
 * Componente que representa el formulario de alta y modificación de un
 * recurso.
 */
export class Panel extends React.Component {
  render() {
    return (
      <div className="section">
        <nav className="panel">
          <p className="panel-heading">{this.props.title}</p>
          <div className="panel-block panel-content">{this.props.children}</div>
        </nav>
      </div>
    );
  }
}

export class Description extends React.Component {
  render() {
    return <p className="field">{this.props.children}</p>;
  }
}

export class Content extends React.Component {
  render() {
    return <section className="box">{this.props.children}</section>;
  }
}

export class FieldItem extends React.Component {
  render() {
    return (
      <div className="field">
        <label className="label">
          {this.props.label}:&nbsp;
          <span>{this.props.children}</span>
        </label>
      </div>
    );
  }
}

export class Wizard extends React.Component {
  render() {
    return (
      <div className="wizard">
        <ul className="wizard-breadcrumbs">{this.props.children}</ul>
      </div>
    );
  }
}

export class Breadcrumb extends React.Component {
  render() {
    return (
      <li className={this.props.active ? "active" : ""}>
        <a>
          {" "}
          {this.props.children}&nbsp;
          <span className="badge">{this.props.badge}</span>
        </a>
      </li>
    );
  }
}
